export default __webpack_public_path__ + "static/media/THYROID-DISEASE.b3714dc7.png";